import { REGION_DISTRIBUTOR_ACTIONS } from "constants/actions";

export function fetchRegionList(id) {
    return {
        type: REGION_DISTRIBUTOR_ACTIONS.FETCH_REGION_DATA,
        payload: {
            id
        }
    };
}

export function fetchedRegionList(id, data) {
    return {
        type: REGION_DISTRIBUTOR_ACTIONS.FETCHED_REGION_DATA,
        payload: {
            id,
            data
        }
    };
}

export function failedFetchRegionList(id, error) {
    return {
        type: REGION_DISTRIBUTOR_ACTIONS.FAILED_FETCH_REGION_DATA,
        payload: {
            id,
            error
        }
    };
}

export function createRegion(companyId, data) {
    return {
        type: REGION_DISTRIBUTOR_ACTIONS.CREATE_REGION,
        payload: {
            companyId,
            data
        }
    };
}

export function createdRegion(companyId, data) {
    return {
        type: REGION_DISTRIBUTOR_ACTIONS.CREATED_REGION,
        payload: {
            companyId,
            data
        }
    };
}

export function failedCreateRegion(companyId, error) {
    return {
        type: REGION_DISTRIBUTOR_ACTIONS.FAILED_CREATE_REGION,
        payload: {
            companyId,
            error
        }
    };
}

export function fetchRegionWiseList(id) {
    return {
        type: REGION_DISTRIBUTOR_ACTIONS.FETCH_REGION_WISE_DATA,
        payload: {
            id
        }
    };
}

export function fetchedRegionWiseList(id, data) {
    return {
        type: REGION_DISTRIBUTOR_ACTIONS.FETCHED_REGION_WISE_DATA,
        payload: {
            id,
            data
        }
    };
}

export function failedFetchRegionWiseList(id, error) {
    return {
        type: REGION_DISTRIBUTOR_ACTIONS.FAILED_FETCH_REGION_WISE_DATA,
        payload: {
            id,
            error
        }
    };
}

